import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectChannels } from '../store/selectors';
import { Modal, FooterButton } from 'Core/components';

/** Value for `<input type="date" />` — local calendar day. */
const formatDateInputValue = (date = new Date()) => {
  const p = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
};

export const ChannelDatePopup = ({ onClose, onSave, show }) => {
  const channels = useSelector(selectChannels);
  const [selectedChannel, setSelectedChannel] = useState('');
  const [startDate, setStartDate] = useState('');
  const [materialBatchNumber, setMaterialBatchNumber] = useState('');
  const [isFormDirty, setIsFormDirty] = useState(false);

  useEffect(() => {
    if (show) {
      setStartDate(formatDateInputValue(new Date()));
    }
  }, [show]);

  useEffect(() => {
    setIsFormDirty(!!selectedChannel && !!startDate && !!materialBatchNumber);
  }, [selectedChannel, startDate, materialBatchNumber]);

  const handleSave = () => {
    onSave({ channel: selectedChannel, startDate, materialBatchNumber });
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const modalContent = (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-12">
          <div className="form-group mb-3">
            <label className="form-label required">Select Cell</label>
            <select
              className="form-select"
              value={selectedChannel}
              onChange={e => setSelectedChannel(e.target.value)}
            >
              <option value="">Select a cell...</option>
              {channels.map(channel => (
                <option key={channel.title} value={channel.uuid}>
                  {channel.title}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group mb-3">
            <label className="form-label required">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label required">Material Batch Number</label>
            <input
              type="text"
              className="form-control"
              value={materialBatchNumber}
              placeholder="Enter material batch number"
              onChange={e => setMaterialBatchNumber(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const footer = () => {
    return (
      <div className="row">
        <div className="col-lg-4"></div>
        <div className="col-lg-8">
          <FooterButton
            cancelText="Cancel"
            saveText="Assign"
            onSave={handleSave}
            onCancel={handleClose}
            disableSave={!isFormDirty}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      title="Schedule task"
      body={modalContent}
      footer={footer}
      size="md"
      handleClose={handleClose}
    />
  );
};
